import React, { useEffect, useMemo } from 'react'
import { Container } from 'react-bootstrap'
import { Footer, KonektoNavbar } from '../../components'
import './MyCompany.scss'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  FaClock,
  FaCheckCircle,
  FaBuilding,
  FaChevronRight,
  FaBoxes,
} from 'react-icons/fa'

export default function MyCompany() {
  const navigate = useNavigate()

  const { token } = useSelector(state => state.authentication)
  const { myCompany } = useSelector(state => state.company)

  const companyStatus = useMemo(() => {
    const isVerified = myCompany?.is_verified

    if (isVerified === null) {
      return (
        <span>
          <b>Status:</b>
          {` Verifikacija firme je u toku `}
          <FaClock color="orange" />
        </span>
      )
    } else if (isVerified === 0) {
      return (
        <span style={{ color: '#ff0033' }}>
          <b>Status:</b>
          {` Verifikacija firme nije uspjela. Ažurirajte podatke kako biste ponovo pokrenuli proces verifikacije.`}
        </span>
      )
    } else if (isVerified === 1) {
      return (
        <span>
          <b>Status:</b>
          {` Firma je verifikovana `}
          <FaCheckCircle color="green" />
        </span>
      )
    } else {
      return null
    }
  }, [myCompany])

  useEffect(() => {
    if (!token) {
      navigate('/prijava')
      return
    }

    if (myCompany === null) {
      navigate('/registracija-firme')
      return
    }
  }, [token, myCompany, navigate])

  return (
    <div id="my-company">
      <KonektoNavbar />
      <Container className="my-5">
        <div className="group-wrapper shadow">
          <h3>{myCompany?.name}</h3>
          {companyStatus}
        </div>

        <div className="d-flex company-sections">
          <div
            onClick={() => {
              navigate('/moja-firma/proizvodi')
            }}
            className="group-wrapper shadow w-100 me-2 d-flex align-items-center">
            <FaBoxes />
            <span className="ms-2 w-100">{`Proizvodi i servisi`}</span>
            <FaChevronRight />
          </div>

          <div
            onClick={() => navigate('/moja-firma/profil')}
            className="group-wrapper shadow w-100 ms-2 d-flex align-items-center">
            <FaBuilding />
            <span className="ms-2 w-100">{`Profil firme`}</span>
            <FaChevronRight />
          </div>
        </div>

        <div className="group-wrapper shadow">
          <h4 className="mb-0">{`Poslovna analitika`}</h4>
          <p className="text-secondary">{`Analiza vaših proizvoda i servisa u zadnjih 12 mjeseci`}</p>

          <div className="d-flex mt-2">
            <div className="w-100">
              <p className="mb-0 fs-3 fw-bold">{myCompany?.views}</p>
              <span>{`Prikazi firme`}</span>
            </div>

            <div className="w-100">
              <p className="mb-0 fs-3 fw-bold">{myCompany?.products_views}</p>
              <span>{`Prikazi proizvoda`}</span>
            </div>

            {/* <div className="w-100">
              <p className="mb-0 fs-3 fw-bold">{`4`}</p>
              <span>{`Primljeni upiti`}</span>
            </div> */}
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  )
}
